module.exports = __webpack_public_path__ + "img/图片25.94d47d9f.png";